import React, { useRef } from 'react';
import { useRainRing, useRainRings } from './use-rain-ring';
export const RainRing = ({ value, style }) => {
    const mesh = useRef();
    useRainRing(mesh, { style });
    return (React.createElement("mesh", { ref: mesh, scale: [0, 0, 0], position: value.startpoint },
        React.createElement("circleGeometry", { attach: "geometry", args: [value.radius, 128] }),
        React.createElement("meshBasicMaterial", { attach: "material", opacity: 0.2, transparent: true, color: "white" })));
};
const RainRings = (props) => {
    const { rings } = useRainRings(props);
    return (React.createElement(React.Fragment, null, rings.map((ring, index) => {
        return React.createElement(RainRing, { key: index, value: ring, style: props.style });
    })));
};
export default RainRings;
